export default __webpack_public_path__ + "static/11006-32a01c86a0f1447eaf6766be565e915e.jpg";